import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { MID_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: { display: "flex", flexDirection: "column" },
  rootActions: {
    borderBottom: `1px solid ${MID_GREY}`,
  },
  overviewContent: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
    padding: 16,
    border: "1px solid #F5F5F5",
  },
  iconContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 36,
    height: 36,
    borderRadius: "200px",
  },
  cardGraph: {
    display: "flex",
    flexDirection: "column",
    padding: 16,
    gap: 16,
    border: "1px solid #F5F5F5",
  },
}));
